import { forwardRef } from "react";
import classNames from "classnames";

import styles from "./RoundedAnchorButton.module.scss";

type RoundedAnchorButtonProps = {
  variant?: "primary" | "secondary" | "ghost";
} & JSX.IntrinsicElements["a"];
// } & JSX.IntrinsicElements["button"];

/**
 * `RoundedAnchorButton` component is used to display Anchor with rounded corners.
 *
 * @param {RoundedAnchorButtonProps} props - The props for the `RoundedAnchorButton` component.
 * @param {React.ReactElement} props.variant - The variant of the Anchor can be (primary, secondary, ghost) (defult: primary).
 * @param {string} props.className - The class name for the root element (Optional).
 */
const RoundedAnchorButton = forwardRef<HTMLAnchorElement, RoundedAnchorButtonProps>(
  ({ variant = "primary", className, ...props }, ref) => {
    const buttonClasses = classNames(styles["rounded-anchor-button-root"], {
      [styles["primary"]]: variant === "primary",
      [styles["secondary"]]: variant === "secondary",
      [styles["ghost"]]: variant === "ghost",
      [className]: className,
    });

    return <a tabIndex={0} ref={ref} className={buttonClasses} {...props} />;
  }
);

export default RoundedAnchorButton;
